/*import "./modernizr-min.js"; // Not required anymore (Breaks customizer)*/
/*import "./jquery.validate.min.js"; // Only required for blog post comment forms*/
/*import "./comment-form-validation.js"; // Only required for blog post comment forms*/
import "./custom.js";
